import { render, staticRenderFns } from "./ScoreTable.vue?vue&type=template&id=750f88ce&scoped=true&"
import script from "./ScoreTable.vue?vue&type=script&lang=js&"
export * from "./ScoreTable.vue?vue&type=script&lang=js&"
import style0 from "./ScoreTable.vue?vue&type=style&index=0&id=750f88ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750f88ce",
  null
  
)

export default component.exports